import { gql } from 'graphql-request';

export const meQuery = gql`
  {
    me {
      confirmed
      email
      role
    }
  }
`;

export const usersQuery = gql`
  {
    users {
      id
      active
      confirmed
      email
      role
      createdAt
    }
  }
`;
